/// REDUX ///
import { useAppDispatch } from "api/hooks/apiHook";
/// ACTIONS ///
import { updateShopFullArc } from "api/actions/price_list";
/// TYPES ///
import { IFullArc } from "api/types/price_list/bump/full_arc";
/// COMPONENTS ///
import PriceRow from "../../row";
/// VALUES ///
import { getMaterialHeightDisplay } from "values/material";

interface Props {
  index: number,
  last: boolean,
  full_arc: IFullArc
}

export default function FullArc({ index, last, full_arc }: Props) {
  const dispatch = useAppDispatch();

  return (
    <PriceRow
      index={index}
      last={last}
      original_price={full_arc?.price ?? 0}
      title={getMaterialHeightDisplay(full_arc?.material_thickness ?? "")}
      end_text="$/LIN"
      end_padding="15px"
      update={price => dispatch(updateShopFullArc({ price: price }, full_arc.id))} />
  )
}
